import { useState, useContext, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import { ProductoFiltroContainer } from './reportesComponents';
import Button from '@mui/material/Button';
import { ReportesContext } from '../../context/ReportesContext';
import { getTimestampWithOffsetFromDate } from '../../extras/utils';
import {  MenuItem, Select } from '@mui/material';
import { obtenerLocales } from '../../services/ReportesService';
import { styles } from '../../productos/components/productosComponents';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(styles);

function Filtros() {
  const { obtenerDatosDelReporte } = useContext(ReportesContext);
  const [desdeFecha, setDesdeFecha] = useState("");
  const [hastaFecha, setHastaFecha] = useState("");
  const [sucursal, setSucursal] = useState("TODAS");
  const [localesDisponibles, setLocalesDisponibles] = useState([]);

  const classes = useStyles();

  async function buscar() {
    try {
      const desdeTimestamp = desdeFecha ? getTimestampWithOffsetFromDate(desdeFecha) : null;
      const hastaTimestamp = hastaFecha ? getTimestampWithOffsetFromDate(hastaFecha) : null;

      await obtenerDatosDelReporte(desdeTimestamp, hastaTimestamp, sucursal);
    } catch (error) {
      console.error('Error al buscar reportes:', error);
      alert('Ocurrió un error al buscar los reportes');
    }
  }

  const obtenerSucursales = async () => {
    const locales = await obtenerLocales();
    setLocalesDisponibles(locales);
  }

  useEffect(() => {
    obtenerSucursales()
  }, []);

  return (
    <div>
      <ProductoFiltroContainer>
        <TextField
          variant='outlined'
          id='date'
          label='desde'
          type='date'
          value={desdeFecha}
          onChange={e => {
            setDesdeFecha(e.target.value);
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          variant='outlined'
          id='date'
          label='hasta'
          type='date'
          inputProps={{
            min: desdeFecha,
          }}
          value={hastaFecha}
          onChange={e => {
            setHastaFecha(e.target.value);
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
          <Select style={{height: 55, width: 200}} className={classes.select} variant="outlined" value={sucursal}
            onChange={e => setSucursal(e.target.value)}
            label='Sucursal'>
            <MenuItem aria-label='Ninguna' defaultValue value='TODAS'>
              TODAS
            </MenuItem>
            {
              localesDisponibles.map(loc => <MenuItem key={loc} value={loc}>{loc}</MenuItem>)
            }
          </Select>
        <Button
          style={{ width: 150, height: 55 }}
          onClick={buscar}
          variant='outlined'
          color='primary'>
          Buscar
        </Button>
      </ProductoFiltroContainer>
    </div>
  );
}


export default Filtros;
